// deps
import React, { memo } from "react";

// styles
import { FooterBlur, FooterContent, FooterWrapper } from "./styles";

// components
import { AssistanceLink } from "./components/assistance-link";
import { TransactionCompleteBtn } from "./components/transaction-complete-btn";

// types
import { IFooter } from "@dineout-payment-success-ui/interfaces";

const Footer: React.FC<IFooter> = ({
    doneClickHandler,
    viewHelpClickHandler,
    showHelpCta = true,
    customDoneCtaText,
    isFullWidthCta = false,
    doneClickEventHandler,
    doneImpressionEventHandler,
    isTransactionBtnV2 = false,
}) => {
    return (
        <FooterWrapper isTransactionBtnV2={isTransactionBtnV2}>
            {isTransactionBtnV2 ? <FooterBlur aria-hidden="true" /> : null}
            <FooterContent>
                <TransactionCompleteBtn
                    customDoneCtaText={customDoneCtaText}
                    doneClickHandler={doneClickHandler}
                    isFullWidthCta={isFullWidthCta}
                    doneClickEventHandler={doneClickEventHandler}
                    doneImpressionEventHandler={doneImpressionEventHandler}
                    isTransactionBtnV2={isTransactionBtnV2}
                />
                {showHelpCta && <AssistanceLink viewHelpClickHandler={viewHelpClickHandler} />}
            </FooterContent>
        </FooterWrapper>
    );
};

export default memo(Footer);
